export default __webpack_public_path__ + "static/media/spaceman2.f8554a7c.png";